export default {
  online: 'online',
  statement: 'statement',
  finReports: 'fin-reports',
  balance: 'balance',
  currencyRates: 'currency-rates',
  statStatement: 'stat-statement',
};
